import { render, staticRenderFns } from "./incl-pharmacy-eigenmarken-kategorien.vue?vue&type=template&id=ae0c75a2&scoped=true"
import script from "./incl-pharmacy-eigenmarken-kategorien.vue?vue&type=script&lang=js"
export * from "./incl-pharmacy-eigenmarken-kategorien.vue?vue&type=script&lang=js"
import style0 from "./incl-pharmacy-eigenmarken-kategorien.vue?vue&type=style&index=0&id=ae0c75a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0c75a2",
  null
  
)

export default component.exports